import { Label } from 'reactstrap';
import TrackLocationMapFilter from '../../filters/TrackLocationFilter';
import React, { useEffect, useRef, useState } from 'react';
import '../../assets/style/TrackLocation.css';
import {
  LastLocationType,
  LoggedUserType,
  TLStatusCountType,
  TrackingDateType,
  TrackingHistoryType,
  TrackLocationFilterType,
  UserType,
} from '../../utils/Types';
import { AdvancedMarker, Map, Pin, useMap } from '@vis.gl/react-google-maps';
import { Image } from 'react-bootstrap';
import {
  clearTrackHistoryList,
  getLastLocationList,
  trackLocationSelector,
} from '../../features/trackLocationSlice';

import MarkerIcon from '../../assets/img/marker_icon.svg';
import MarkerIconRed from '../../assets/img/marker_icon_red.svg';
import ProfileMarker from '../../components/ProfileMarker';
import MarkerToolTip from '../../components/MarkerToolTip';
import TrackLocationHistory from './TrackLocationHistory';
import { GOOGLE_MAP_ID } from '../../utils/Config';
import { useLocation, useNavigate } from 'react-router-dom';
import CenterSpinner from '../../components/CenterSpinner';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { loginSelector } from '../../features/loginSlice';
import ToggleSwitch from '../../components/ToggleSwitch';
import {
  getFindLocationRequest,
  getLineAndToolTip,
  makeZoomCenter,
  onDataChange,
  onUserMarkerClick,
  showTollTip,
} from './TrackLocationHelper';
import { useLoader } from '../../loader/LoaderProvider';
import {
  CLICK_ACTIONS,
  DATE_FORMAT,
  defaultFilter,
} from '../../utils/Constant';
import moment from 'moment';
import { updateSelectedMenu } from '../../features/dashboardSlice';

export type Polyline = google.maps.Polyline;
const positionDefault = { lat: 17.38405, lng: 78.45636 };

const TrackLocationMap: React.FunctionComponent = () => {
  const mapInstance = useMap();
  const [trackLocationFilter, setTrackLocationFilter] =
    useState<TrackLocationFilterType>();
  const { showLoader, setShowLoader } = useLoader();
  const [polylineLatLngList, setPolylineLatLngList] = useState<any[]>([]);
  const [selectedUserLastLocation, setSelectedUserLastLocation] =
    useState<LastLocationType | null>();
  const [toolTipStatus, setToolTipStatus] = useState<boolean[] | null>();
  const [trackingDate, setTrackingDate] = useState<TrackingDateType>();
  const location = useLocation();
  const [refreshKey, setRefreshKey] = useState(0);
  const [taskCounter, setTaskCounter] = useState(0);
  const [fgBgCounter, setfgBgCounter] = useState(0);
  const locationListError: string | null = useAppSelector(
    trackLocationSelector
  ).locationListError;
  const employeeLastLocationList: LastLocationType[] = useAppSelector(
    trackLocationSelector
  ).lastLocationList;
  const trackHistoryList: TrackingHistoryType[] = useAppSelector(
    trackLocationSelector
  ).trackHistoryList;
  const trackMarkerList: TrackingHistoryType[] = useAppSelector(
    trackLocationSelector
  ).trackMarkerList;
  const statusCount: TLStatusCountType = useAppSelector(
    trackLocationSelector
  ).statusCount;
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const [directionsRenderers, setDirectionsRenderers] = useState<
    google.maps.DirectionsRenderer[]
  >([]);
  const [markerList, setmarkerList] = useState<any[]>([]);
  const isRedirectHandled = useRef(false);
  const [showAttendanceMarker, setShowAttendanceMarker] = useState(false);

  const dispatch = useAppDispatch();

  const [activeMarker, setActiveMarker] = React.useState<number | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.viewtask) {
      window.history.pushState(null, '', window.location.href);
    }

    const handleBackButton = () => {
      console.log('BACK BUTTON CLICKED');

      if (location.state?.viewtask) {
        dispatch(updateSelectedMenu('view-task'));

        navigate('/view-task', {
          replace: true,
          state: {
            taskId: location.state?.taskid,
            action: CLICK_ACTIONS.CLOSE_VIEW_TASK,
            scrollToBottom: true,
          },
        });
      }
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  useEffect(() => {
    console.log('track location refreshed');
    const interval = setInterval(
      () => {
        const currentTime = new Date().toLocaleString();
        console.log(`Location list refreshed at: ${currentTime}`);

        setRefreshKey((prev) => prev + 1); // Triggers re-render or data fetch
        findLocationList(trackLocationFilter); // Re-fetch location data
      },
      20 * 60 * 1000
    ); // 20 minutes
    return () => clearInterval(interval); // Cleanup on unmount
  }, [trackLocationFilter]);

  useEffect(() => {
    console.log('markers list', trackMarkerList, selectedUserLastLocation);
    setmarkerList(trackMarkerList);
  }, [trackMarkerList]);

  const clearData = () => {
    dispatch(clearTrackHistoryList());
    setPolylineLatLngList([]);
    setToolTipStatus(null);
    directionsRenderers.forEach((renderer) => {
      renderer.setMap(null);
    });
    setDirectionsRenderers([]);
  };
  const parsedCheckIn = (() => {
    if (!location.state?.checkInLocation) return null;

    const parts = location.state?.checkInLocation.split(',');

    if (parts.length !== 2) return null;

    const lat = Number(parts[0].trim());
    const lng = Number(parts[1].trim());

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

    return { lat, lng };
  })();
  const parsedStartLocation = (() => {
    if (!location.state?.startLocation) return null;

    const parts = location.state?.startLocation.split(',');

    if (parts.length !== 2) return null;

    const lat = Number(parts[0].trim());
    const lng = Number(parts[1].trim());

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

    return { lat, lng };
  })();
  const findLocationList = (trackLocationFilter?: TrackLocationFilterType) => {
    clearData();
    setSelectedUserLastLocation(null);
    setShowLoader(true);
    dispatch(
      getLastLocationList(
        getFindLocationRequest(
          setTrackingDate,
          user,
          userDetails,
          trackLocationFilter
        )
      )
    );
  };
  // **Make API request to Google Directions API**
  const getRoute = (
    directionsService: google.maps.DirectionsService,
    request: google.maps.DirectionsRequest
  ) => {
    return new Promise<google.maps.DirectionsResult | null>((resolve) => {
      directionsService.route(request, (result, status) => {
        if (status === 'OK' && result) {
          resolve(
            result.routes.length > 0
              ? { ...result, routes: [result.routes[0]] }
              : null
          );
        } else {
          console.error('Directions request failed:', status);
          resolve(null);
        }
      });
    });
  };
  // **Break waypoints into multiple requests**
  const getSegmentedRoutes = async (line: any[], directionsService: any) => {
    const routes = [];
    const MAX_WAYPOINTS = 23; // Google API allows max 23 waypoints per request
    for (let i = 0; i < line.length - 1; i += MAX_WAYPOINTS) {
      const start = i;
      const end = Math.min(i + MAX_WAYPOINTS, line.length - 1);
      const waypoints = line.slice(start + 1, end).map((point) => ({
        location: new google.maps.LatLng(point.lat, point.lng),
        stopover: true, // Enforce exact travel points
      }));
      const request = {
        origin: new google.maps.LatLng(line[start].lat, line[start].lng),
        destination: new google.maps.LatLng(line[end].lat, line[end].lng),
        waypoints,
        travelMode: google.maps.TravelMode.DRIVING,
        optimizeWaypoints: false,
        provideRouteAlternatives: false,
        avoidHighways: false,
        avoidTolls: false,
      };
      const result = await getRoute(directionsService, request);
      if (result) {
        routes.push(result);
      }
    }
    return routes;
  };
  /**
   * Sort the trackHistoryList on the basis of time and find the distance between two lat and lng.
   */
  const onTrackingHistoryReceived = async () => {
    setShowLoader(false);
    if (!trackHistoryList || trackHistoryList.length === 0) return;
    const { line, toolTip } = getLineAndToolTip(trackHistoryList);

    if (mapInstance) {
      mapInstance.setCenter(line[0]);
      if (mapInstance.getZoom()) {
        mapInstance.setZoom(20);
      }
    }

    setToolTipStatus(toolTip);
    setPolylineLatLngList(line);
    if (line.length === 0) return;
    const directionsService = new google.maps.DirectionsService();
    setDirectionsRenderers((prevRenderers) => {
      prevRenderers.forEach((renderer) => renderer.setMap(null));
      return [];
    });
    const routes = await getSegmentedRoutes(line, directionsService);
    const newRenderers: google.maps.DirectionsRenderer[] = [];
    routes.forEach((result) => {
      if (result) {
        const segmentRenderer = new google.maps.DirectionsRenderer({
          suppressMarkers: true,
          preserveViewport: true,
          polylineOptions: {
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 5,
          },
        });
        segmentRenderer.setMap(mapInstance);
        segmentRenderer.setDirections(result);
        newRenderers.push(segmentRenderer);
      }
    });
    setDirectionsRenderers(newRenderers);
  };
  const onProfileMarkerClick = (
    lastLocation: LastLocationType,
    selectedDate?: string
  ) => {
    setSelectedUserLastLocation(lastLocation);
    setTrackingDate({
      date: moment
        .utc(lastLocation.locationreceivedat)
        .format(DATE_FORMAT.YYYY_MM_DD),
      activeDateNumber: 1,
    });
    onUserMarkerClick(
      clearData,
      dispatch,
      setShowLoader,
      lastLocation.employeeid,
      lastLocation.locationreceivedat
        ? moment
            .utc(lastLocation.locationreceivedat)
            .format(DATE_FORMAT.YYYY_MM_DD)
        : selectedDate,
      trackingDate
    );
  };

  useEffect(() => {
    setShowLoader(false);
    onTrackingHistoryReceived();
  }, [trackHistoryList]);
  useEffect(() => {
    setShowLoader(false);
  }, [employeeLastLocationList]);
  useEffect(() => {
    if (mapInstance) {
      makeZoomCenter(mapInstance, employeeLastLocationList, locationListError);
    }
  }, [employeeLastLocationList, mapInstance]);

  useEffect(() => {}, [mapInstance]);
  useEffect(() => {
    onDataChange(
      userDetails,
      mapInstance,
      location,
      setTrackingDate,
      onProfileMarkerClick,
      findLocationList,
      trackLocationFilter
    );
  }, [location, mapInstance, user, userDetails]);

  const lastFlagRef = useRef<number | null>(null);
  // Keep using the unique trigger string
  const [triggerUserSelect, setTriggerUserSelect] = useState<string | null>(
    null
  );

  useEffect(() => {
    // Reset flag if a brand-new redirect arrives
    if (
      location.state?.redirectFlag &&
      location.state.redirectFlag !== lastFlagRef.current
    ) {
      isRedirectHandled.current = false;
      lastFlagRef.current = location.state.redirectFlag;

      // Force a completely unique string signature on EVERY single click sequence
      setTriggerUserSelect(
        `${location.state.employeeId}-${location.state.redirectFlag}-${Date.now()}`
      );
    }

    if (
      location.state?.employeeId &&
      location.state?.date &&
      !isRedirectHandled.current
    ) {
      const { candidateUniqueID, date } = location.state;
      const nativeDate = new Date(date);

      const updatedFilter = {
        ...defaultFilter,
        employeeId: candidateUniqueID,
        date: nativeDate,
      } as TrackLocationFilterType;

      setShowAttendanceMarker(true);
      setTrackLocationFilter(updatedFilter);

      findLocationList(updatedFilter);
    }
  }, [location.state]);

  useEffect(() => {
    if (
      triggerUserSelect &&
      employeeLastLocationList?.length > 0 &&
      !showLoader &&
      !isRedirectHandled.current
    ) {
      const activeTarget = employeeLastLocationList.find(
        (loc) => loc?.employeeid === location.state?.employeeId
      );
      console.log('activeTarget', activeTarget);

      if (activeTarget) {
        setSelectedUserLastLocation(activeTarget);

        setTrackingDate({
          date: moment(location.state?.date).format(DATE_FORMAT.YYYY_MM_DD),
          activeDateNumber: 1,
        });

        onUserMarkerClick(
          clearData,
          dispatch,
          setShowLoader,
          activeTarget.employeeid,
          location.state?.date,
          trackingDate
        );

        // Explicitly zoom and center map if opening the same user back-to-back
        if (mapInstance) {
          if (parsedCheckIn) {
            mapInstance.setCenter(parsedCheckIn);
            mapInstance.setZoom(15);
          } else if (activeTarget.latitude && activeTarget.longitude) {
            const targetLatLng = {
              lat: parseFloat(activeTarget.latitude),
              lng: parseFloat(activeTarget.longitude),
            };
            mapInstance.setCenter(targetLatLng);
            mapInstance.setZoom(15);
          }
        }

        isRedirectHandled.current = true;
        setTriggerUserSelect(null);
      } else {
        // ⚠️ FALLBACK SAFETY CHECK:
        // If we didn't find the employee, check if the data array still belongs to the previous user.
        // If the array contains the previous employee ID instead of the new one, exit early and wait for Redux to finish rewriting the list.
        const isStaleData = employeeLastLocationList.some(
          (loc) => loc?.employeeid !== location.state?.employeeId
        );

        if (isStaleData) {
          console.log(
            'Detected stale data from the previous employee. Waiting for Redux update...'
          );
          return;
        }

        // ✅ GENUINE EMPTY/NOT FOUND BRANCH:
        // This will only run if the list updated, cleared out the old user,
        // and this specific employee simply doesn't exist on this date.
        console.warn(
          `Employee ID ${location.state?.employeeId} completely missing from this date's records.`
        );

        isRedirectHandled.current = true;

        setTimeout(() => {
          setTriggerUserSelect(null);
        }, 0);
      }
    }
  }, [employeeLastLocationList, triggerUserSelect, showLoader, mapInstance]);

  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };
  const getDistanceTravelledAndTime = (
    index: number,
    trackHistoryList: any
  ) => {
    if (index != trackHistoryList.length - 1) {
      const distance = `${trackHistoryList[index]?.distanceTravelled ?? '-'} kms`;
      const time = trackHistoryList[index]?.timeTaken ?? '-';
      return `${distance} | ${time}`;
    } else return ' - | -';
  };
  const getMarkerLabel = (index: number, trackHistoryList: any[]) => {
    let taskCounter = 0;
    let fgBgCounter = 0;

    // ✅ loop from END to START to match your reversed rendering
    for (let i = trackHistoryList.length - 1; i >= 0; i--) {
      const item = trackHistoryList[i];

      const statusMatch = [
        'closed',
        'postponed',
        'reached destination',
      ].includes(item?.statusName?.toLowerCase?.() || '');

      const isFG_BG =
        item?.referenceModuleName === 'App ForeGround' ||
        item?.referenceModuleName === 'App BackGround';

      if (statusMatch) {
        taskCounter++;
        if (i === index) {
          return String.fromCharCode(64 + taskCounter); // A, B, C
        }
      }

      if (isFG_BG) {
        fgBgCounter++;
        if (i === index) {
          return fgBgCounter; // 1,2,3
        }
      }
    }

    return '';
  };
  return (
    <div className="ml-4 size-100">
      <Label className="text-heading">Track Location</Label>
      <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />
      <div className="task-item-parent-view">
        {showFilter && (
          <TrackLocationMapFilter
            filterValue={trackLocationFilter}
            isFromAttendance={showAttendanceMarker}
            onApplyFilters={(trackLocationFilter: TrackLocationFilterType) => {
              setShowAttendanceMarker(false);
              setTrackLocationFilter(trackLocationFilter);
              findLocationList(trackLocationFilter);
            }}
            locationData={location}
          />
        )}
        {!selectedUserLastLocation && (
          <div className="d-flex justify-content-end">
            <Label className="mt-2 active-emp">
              {!trackLocationFilter ||
              trackLocationFilter?.status?.value === 'Logged'
                ? 'Logged Employees'
                : trackLocationFilter?.status?.value === 'Not-Logged'
                  ? 'Not-Logged Employees'
                  : 'Logged Employees'}
              : {statusCount?.userCount} /
            </Label>
            <Label className="mt-2 active-total">
              {statusCount.totalUsers}
            </Label>
          </div>
        )}
        <div
          className={`${!selectedUserLastLocation ? 'mt-1' : 'mt-3'} pb-4 size-map`}
        >
          <Map
            key={refreshKey}
            defaultCenter={positionDefault}
            defaultZoom={11}
            gestureHandling="greedy"
            mapId={GOOGLE_MAP_ID}
          >
            {showAttendanceMarker ? (
              <AdvancedMarker position={parsedCheckIn}>
                <Pin
                  background="#000000"
                  glyphColor="#ffffff"
                  borderColor="#ffffff"
                  scale={2} // big marker
                />
              </AdvancedMarker>
            ) : null}
            {showAttendanceMarker && parsedStartLocation ? (
              <AdvancedMarker position={parsedStartLocation}>
                <Pin
                  background="#000000"
                  glyphColor="#ffffff"
                  borderColor="#ffffff"
                  scale={2} // big marker
                />
              </AdvancedMarker>
            ) : null}
            {!selectedUserLastLocation &&
              employeeLastLocationList?.length > 0 &&
              employeeLastLocationList?.map(
                (lastLocation: LastLocationType) => (
                  <div key={lastLocation.candidateuniqueid}>
                    {Number.isFinite(Number(lastLocation.latitude)) &&
                      Number.isFinite(Number(lastLocation.longitude)) && (
                        <ProfileMarker
                          photo={lastLocation.photo}
                          lastLocation={lastLocation}
                          name={lastLocation.employeename}
                          roleName={lastLocation.rolename}
                          onUserMarkerClick={(
                            lastLocation: LastLocationType
                          ) => {
                            onProfileMarkerClick(lastLocation);
                          }}
                          enableHover={true}
                        />
                      )}
                  </div>
                )
              )}

            {selectedUserLastLocation &&
              polylineLatLngList &&
              polylineLatLngList.length > 1 && (
                <AdvancedMarker position={polylineLatLngList[0]}>
                  <Image src={MarkerIcon} />
                </AdvancedMarker>
              )}

            {selectedUserLastLocation &&
              polylineLatLngList &&
              polylineLatLngList.length > 1 && (
                <AdvancedMarker
                  position={polylineLatLngList[polylineLatLngList.length - 1]}
                >
                  <Image src={MarkerIconRed} />
                </AdvancedMarker>
              )}
            {selectedUserLastLocation &&
              trackHistoryList &&
              trackHistoryList.length > 0 && (
                <ProfileMarker
                  photo={
                    selectedUserLastLocation?.photo
                      ? selectedUserLastLocation?.photo
                      : ''
                  }
                  name={selectedUserLastLocation.employeename}
                  roleName={selectedUserLastLocation.rolename}
                  lastLocation={
                    {
                      ...trackHistoryList[0],
                      status: selectedUserLastLocation.status,
                    } as any
                  }
                  markerColour={
                    trackHistoryList?.filter(
                      (item: any) =>
                        item?.referenceModuleName === 'Attendance CheckOut'
                    )?.[0]?.markerColor === '#56B38F'
                      ? true
                      : false
                  }
                  enableHover={false}
                />
              )}

            {selectedUserLastLocation &&
              Array.isArray(markerList) &&
              markerList.length > 0 &&
              markerList.map((m, index) => {
                // Convert lat/lng to numbers safely
                const lat = Number(m.latitude);
                const lng = Number(m.longitude);
                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

                const position: google.maps.LatLngLiteral = { lat, lng };

                const GREEN = '#56B38F';
                const RED = '#F51F1F';
                const Pink = '#fc0390';
                const Blue = '#1565C0';

                const background =
                  m?.markerColor === RED
                    ? RED
                    : m?.markerColor === GREEN
                      ? GREEN
                      : m?.markerColor === Pink
                        ? Pink
                        : m?.markerColor === Blue
                          ? Blue
                          : '#1976D2';

                return (
                  <AdvancedMarker
                    key={`${lat},${lng}-${index}`}
                    position={position}
                    title={m?.referenceModuleName ?? ''}
                    // onClick={() => setActiveMarker(index)}
                  >
                    <div
                      onMouseOver={() => setActiveMarker(index)}
                      onMouseOut={() => setActiveMarker(null)}
                      style={{ display: 'inline-block' }}
                      key={`${index}`}
                    >
                      <Pin
                        background={background}
                        borderColor="#ffffff"
                        glyphColor="#ffffff"
                        scale={1.25}
                      />

                      <div
                        key={m?.status}
                        className={`marker-bg ${m?.markerColor == '#56B38F' || m?.markerColor == '#fc0390' || m?.markerColor == '#1565C0' ? 'bg-true' : 'bg-false'}`}
                      ></div>
                      {activeMarker === index && (
                        <div
                          style={{
                            position: 'absolute',
                            transform: 'translate(-50%, -120%)',
                            background: 'white',
                            padding: '6px 10px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            boxShadow: '0 3px 10px rgba(0,0,0,0.3)',
                            whiteSpace: 'nowrap',
                            pointerEvents: 'none',
                          }}
                        >
                          <strong>{m?.referenceModuleName}</strong>
                        </div>
                      )}
                    </div>
                  </AdvancedMarker>
                );
              })}

            {selectedUserLastLocation &&
              polylineLatLngList &&
              polylineLatLngList.length > 0 &&
              polylineLatLngList
                .slice()
                .reverse()
                .map((item, index) => {
                  // Ensure we properly format latitude/longitude
                  const isTaskModule =
                    trackHistoryList[index]?.referenceModuleName === 'Task';

                  const markerPosition = isTaskModule
                    ? new google.maps.LatLng(
                        parseFloat(trackHistoryList[index]?.latitude),
                        parseFloat(trackHistoryList[index]?.longitude)
                      )
                    : new google.maps.LatLng(
                        parseFloat(item.lat),
                        parseFloat(item.lng)
                      );

                  return (
                    <AdvancedMarker
                      key={`${markerPosition.lat()},${markerPosition.lng()}`} // Ensure correct key format
                      position={markerPosition} // Pass LatLng instance
                      onClick={() => {}}
                    >
                      <MarkerToolTip
                        data={trackHistoryList[index]}
                        address={trackHistoryList?.[index]?.locationName ?? ''}
                        showToolTip={
                          toolTipStatus ? toolTipStatus[index] : false
                        }
                        setShowToolTip={(show: boolean) => {
                          const array = toolTipStatus?.map((value, i) =>
                            i === index ? show : value
                          );
                          setToolTipStatus(array);
                        }}
                        distanceTravelledAndTime={getDistanceTravelledAndTime(
                          index,
                          trackHistoryList
                        )}
                        indexNumber={index}
                        label={getMarkerLabel(index, trackHistoryList)}
                      />
                    </AdvancedMarker>
                  );
                })}
          </Map>
        </div>
        {selectedUserLastLocation && (
          <TrackLocationHistory
            selectedDate={trackingDate?.date}
            activeDateNumber={trackingDate?.activeDateNumber}
            trackHistoryList={polylineLatLngList}
            showTollTip={(index: number) => {
              showTollTip(setToolTipStatus, index, toolTipStatus);
            }}
            lastLocation={selectedUserLastLocation}
            onTrackingDateChange={(date: string, activeDateNumber: number) => {
              setShowAttendanceMarker(false);
              setTrackingDate((prev: any) => ({
                ...prev,
                activeDateNumber: activeDateNumber,
              }));
              onUserMarkerClick(
                clearData,
                dispatch,
                setShowLoader,
                selectedUserLastLocation?.employeeid,
                date,
                trackingDate
              );
            }}
          />
        )}
      </div>
      <CenterSpinner showLoader={showLoader} className="spinner-60" />
    </div>
  );
};

export default TrackLocationMap;
